<template>
  <v-card v-bind="$attrs" v-on="$listeners" :loading="loading">
    <v-card-title class="headline">Earned</v-card-title>
    <v-card-subtitle>
      <span
        v-if="
          this.selectedFiscalYear && this.selectedFiscalYear.fiscalYearStart && this.selectedFiscalYear.fiscalYearEnd
        "
        ><b
          >({{ this.selectedFiscalYear.fiscalYearStart | formatDateClient("MM/DD/YYYY", selectedClient) }} -
          {{ this.selectedFiscalYear.fiscalYearEnd | formatDateClient("MM/DD/YYYY", selectedClient) }})</b
        ><br
      /></span>
      Total amount earned in this program!</v-card-subtitle
    >
    <v-card-text class="display-2 text-center" v-if="result">
      {{ result.calculatedAmount | toNumber(2, selectedProgram) }}
      {{ result.calculatedAmountCurrency ? result.calculatedAmountCurrency : "" }}
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CompanyEarnedWidget",
  props: {
    keyword: String
  },
  data() {
    return {
      loading: true,
      result: null
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let filters = {
        submitted: true,
        closed: true,
        approved: true,
        organization: { id: this.selectedParticipant.organization?.id },
        fiscalYear: this.selectedFiscalYear ? this.selectedFiscalYear.fiscalYear : null
      };

      if (this.keyword && this.keyword.length > 0) {
        filters.keyword = this.keyword;
      }

      this.$api
        .post("/api/claims/search/sumCalculatedTotalEarnedAmountForOrganization", filters)
        .then(({ data }) => {
          this.result = data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    selectedFiscalYear() {
      this.getData();
    },
    keyword() {
      this.getData();
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient", "selectedProgram", "selectedFiscalYear"])
  }
};
</script>
